import Immutable from 'immutable';

const Content: {
  screened: boolean,
  ruling: number | null,
  rulingReq: number | null,
  angle: number | null,
  angleReq: number | null,
  angleDir: string | null,
  dotShape: string | null,
  dotShapeReq: string | null,
  dotName: string | null,
  singlePressDgc: string | null,
  autoPlateDgcCt: string | null,
  autoPlateDgcLw: string | null,
  autoPlateDgcReq: string | null,
  autoPressDgcCt: string | null,
  autoPressDgcLw: string | null,
  autoPressDgcReq: string | null,
  autoCorrectionDgcCt: string | null,
  autoCorrectionDgcLw: string | null,
  autoCorrectionDgcReq: string | null,
  autoCorrectionDgcOrder: string | null,
  totalDgcCt: string | null,
  totalDgcLw: string | null
} = {
  screened: false,
  ruling: -1,
  rulingReq: -1,
  angle: -1,
  angleReq: -1,
  angleDir: null,
  dotShape: null,
  dotShapeReq: null,
  dotName: null,
  singlePressDgc: null,
  autoPlateDgcCt: null,
  autoPlateDgcLw: null,
  autoPlateDgcReq: null,
  autoPressDgcCt: null,
  autoPressDgcLw: null,
  autoPressDgcReq: null,
  autoCorrectionDgcCt: null,
  autoCorrectionDgcLw: null,
  autoCorrectionDgcReq: null,
  autoCorrectionDgcOrder: null,
  totalDgcCt: null,
  totalDgcLw: null
};

class FileInfoScreenAndDgc extends Immutable.Record(Content) {
}

export default FileInfoScreenAndDgc;
